// extracted by mini-css-extract-plugin
export var cardHeader = "_gr-1";
export var contentCard = "_gr-0";
export var headerActions = "_gr-3";
export var reorderHandle = "_gr-5";
export var titleArea = "_gr-2";
export var titleAreaWithHandle = "_gr-4";